import styled, { DefaultTheme } from 'styled-components'

import { variables } from 'src/Styled/variables'

import { ButtonType } from './ButtonProps'

interface StyledComponentsProps {
  type: ButtonType
  disabled?: boolean
}

type ColorSet = Record<string, string>

const PAYPAL_BLUE = '#0070BA'
const BUTTON_RED = '#FD2C55'

const getColors = (type: ButtonType, theme: DefaultTheme): ColorSet => {
  switch (type) {
    case 'green':
      return {
        border: theme.color.brandGreen,
        color: theme.color.white,
        background: theme.color.brandGreen,
        hoverBackground: theme.color.brandGreen,
        activeBackground: theme.color.brandGreen,
        activeColor: theme.color.white,
        focusBackground: theme.color.brandGreen,
        focusColor: theme.color.white,
        disabledBorder: theme.color.mediumGrey,
        disabledBackground: theme.color.mediumGrey,
        disabledColor: theme.color.white,
      }
    case 'red':
      return {
        border: BUTTON_RED,
        color: theme.color.white,
        background: BUTTON_RED,
        hoverBackground: BUTTON_RED,
        activeBackground: BUTTON_RED,
        activeColor: theme.color.white,
        focusBackground: BUTTON_RED,
        focusColor: theme.color.white,
        disabledBorder: theme.color.mediumGrey,
        disabledBackground: theme.color.mediumGrey,
        disabledColor: theme.color.white,
      }
    case 'paypal':
      return {
        border: PAYPAL_BLUE,
        color: theme.color.white,
        background: PAYPAL_BLUE,
        hoverBackground: PAYPAL_BLUE,
        activeBackground: PAYPAL_BLUE,
        activeColor: theme.color.white,
        focusBackground: PAYPAL_BLUE,
        focusColor: theme.color.white,
        disabledBorder: PAYPAL_BLUE,
        disabledBackground: PAYPAL_BLUE,
        disabledColor: theme.color.white,
      }
    default:
      return getColors('green', theme)
  }
}
export const StyledButton = styled.div<StyledComponentsProps>`
  width: 100%;
  .ant-btn.ant-btn-default {
    width: 100%;
    outline: none;
    box-sizing: border-box;
    border: 1px solid ${({ type, theme }) => getColors(type, theme).border};
    border-radius: 27px;

    height: 40px;
    color: ${({ type, theme }) => getColors(type, theme).color};
    cursor: pointer;
    font-size: ${variables.fontSize14};
    background-color: ${({ type, theme }) => getColors(type, theme).background};
    transition: all 0.2s;
    &:hover {
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      background: ${({ type, theme }) =>
        getColors(type, theme).hoverBackground};
      color: ${({ type, theme }) => getColors(type, theme).color};
      border: ${({ type, theme }) =>
        `1px solid ${getColors(type, theme).border}`};
    }
    &:active {
      box-shadow: inset 0 4px 6px rgba(0, 0, 0, 0.1);
      border: ${({ type, theme }) =>
        `1px solid ${getColors(type, theme).border}`};
      background: ${({ type, theme }) =>
        getColors(type, theme).activeBackground};
      color: ${({ type, theme }) => getColors(type, theme).activeColor};
    }
    &:focus {
      border: ${({ type, theme }) =>
        `1px solid ${getColors(type, theme).border}`};
      background: ${({ type, theme }) =>
        getColors(type, theme).focusBackground};
      color: ${({ type, theme }) => getColors(type, theme).focusColor};
    }

    transition-delay: 0.3s;
  }
  .ant-btn > span {
    display: flex;
  }

  .ant-btn[disabled],
  .ant-btn[disabled]:hover,
  .ant-btn[disabled]:focus,
  .ant-btn[disabled]:active {
    border: 1px solid
      ${({ type, theme }) => getColors(type, theme).disabledBorder};
    border-radius: 27px;
    background: ${({ type, theme }) =>
      getColors(type, theme).disabledBackground};
    color: ${({ type, theme }) => getColors(type, theme).disabledColor};
    box-shadow: none;
    cursor: not-allowed;
  }
`
export const IconWithContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  justify-content: center;

  svg {
    flex-shrink: 0;
  }
`
